
import { combineReducers } from './common';
import {
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_ERROR,
  CREATE_SUBSCRIPTION_SUCCESS
} from '../actions/subscriptions';
import { REQUEST_PRODUCTS_SUCCESS, SET_CURRENT_PRODUCT, TARGET_PLAN_PERIODICITY, PERIODICITY } from '../actions/products';

const errors = (state = [], action) => {
  switch (action.type) {
    case CREATE_SUBSCRIPTION_ERROR:
      return state.concat([action.error.errors]);
    default:
      return state;
  }
}

const clientStates = combineReducers({
  errors,
  subscribing: (state=null, action) => {
    switch( action.type ) {
      case CREATE_SUBSCRIPTION:
        return { planId: action.planId };
      case CREATE_SUBSCRIPTION_ERROR:
      case CREATE_SUBSCRIPTION_SUCCESS:
        return null;
      default: 
        return state;
    }
  }
});

const product = (state = {}, action) => ({
  ...state,
  ...action.product,
  ...clientStates(state, action)
});

const withId = id => (state = {}, action) => ({
  ...state,
  [id]: {
    id,
    ...product(state[id], action)
  }
});

const add = (state, product) =>
  withId(product.id)(state, { product });

export default function productsById(state = {}, action) {
  const { productId } = action;

  if (productId) {
    return withId(productId)(state, action);
  }

  switch (action.type) {
    case CREATE_SUBSCRIPTION_SUCCESS:
      return withId(action.subscription.plan.product.id)(state, action);
    case REQUEST_PRODUCTS_SUCCESS:
      return action.items
        .reduce(add, state);
    default:
      return state;
  }
}

export const currentProduct = (state = null, action) => {
  if( action.type === SET_CURRENT_PRODUCT ) {
    return action.productId;
  }
  return state;
}

export const planTargetPeriodicity = (state = PERIODICITY.MONTHLY, action) => {
  if (action.type === TARGET_PLAN_PERIODICITY) {
    return action.periodicity;
  }
  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/products.js